var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPostEventRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPostEventRed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.0%",
    y: "-18.0%",
    width: "136.0%",
    height: "136.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.968627451   0 0 0 0 0.419607843   0 0 0 0 0.274509804  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-JS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RedHotPie-Premium+-upgrade",
    transform: "translate(-9.000000, -1021.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 807.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icPostEventRed",
    transform: "translate(15.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.0880016,25.7251749 L38.1216564,18.0493511 C38.2772031,17.9039736 38.324907,17.6766786 38.2409333,17.4810314 C38.1531483,17.2813226 37.9538693,17.1540055 37.7357603,17.158282 L23.6470453,17.158282 C23.3446272,14.188095 20.815566,11.9458031 17.8305389,12.0013071 C14.6840603,11.9346468 12.0766204,14.4259913 12,17.5722432 C12.0766204,20.7184951 14.6840603,23.2098396 17.8305389,23.1431793 C18.8976741,23.1475864 19.9465799,22.8665863 20.8685935,22.3292894 L24.4398863,25.7251749 C25.0676148,26.3200104 25.8690563,26.6986054 26.7271976,26.8056839 L26.7271976,37.9615887 L22.3349986,37.9615887 C22.0482493,37.9615887 21.815793,38.194045 21.815793,38.4807944 C21.815793,38.7675437 22.0482493,39 22.3349986,39 L32.1578079,39 C32.4445572,39 32.6770135,38.7675437 32.6770135,38.4807944 C32.6770135,38.194045 32.4445572,37.9615887 32.1578079,37.9615887 L27.8006903,37.9615887 L27.8006903,26.8056839 C28.6588317,26.6986054 29.4602731,26.3200104 30.0880016,25.7251749 Z M32.8945186,21.3259596 L21.6333694,21.3259596 C21.4692082,21.3251758 21.3113743,21.2625433 21.191343,21.1505523 L18.384826,18.4352472 C18.3441771,18.3979548 18.3306958,18.3394783 18.3509147,18.2881534 C18.3711337,18.2368285 18.4208758,18.2032582 18.4760378,18.203705 L36.0869316,18.203705 C36.1420936,18.2032582 36.1918358,18.2368285 36.2120547,18.2881534 C36.2322736,18.3394783 36.2187923,18.3979548 36.1781434,18.4352472 L33.3716265,21.143536 C33.2435495,21.2659605 33.0716017,21.3317052 32.8945186,21.3259596 L32.8945186,21.3259596 Z M17.8305389,22.1047681 C15.2719362,22.1557751 13.1526352,20.1305259 13.0875253,17.5722432 C13.1526352,15.0139605 15.2719362,12.9887113 17.8305389,13.0397184 C20.2281317,12.9976288 22.2684301,14.7772055 22.5525037,17.158282 L16.7640625,17.158282 C16.5484891,17.1568395 16.3526921,17.2836939 16.2659057,17.4810314 C16.1802016,17.6752418 16.2250554,17.9023141 16.3781664,18.0493511 L20.0687362,21.5574973 C19.3756902,21.9123246 18.6091211,22.0997616 17.8305389,22.1047681 L17.8305389,22.1047681 Z",
    id: "Shape",
    fill: "#F76B46",
    fillRule: "nonzero"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPostEventRed);
export default __webpack_public_path__ + "static/media/icPostEventRed.baf67017af3dcd728e559d6f8a2718c5.svg";
export { ForwardRef as ReactComponent };